
import { mapState, mapGetters } from 'vuex'
export default {
  props: {
    simplified: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    },
    linksWithModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      publicPath: process.env.publicPath
    }
  },
  computed: {
    ...mapState(['contentPage', 'mainConfig']),
    ...mapGetters(['isRolB2b']),
    responsive() {
      return window.innerWidth < 768
    }
  },
  mounted() {
    this.addScript()
  },
  methods: {
    addScript() {
      /*       let script = document.createElement('script')
      script.src = 'https://www.google.com/recaptcha/api.js'
      script.async = true
      script.defer = true
      document.body.appendChild(script) */
      window.__dcid = window.__dcid || []
      window.__dcid.push({ cid: 'DigiCertClickID_U_Rv_I8q', tag: 'U_Rv_I8q' })
      var cid = document.createElement('script')
      cid.async = false
      cid.src = '//seal.digicert.com/seals/cascade/seal.min.js'
      document.body.appendChild(cid)
      /* var s = document.getElementsByTagName('script')
      var ls = s[s.length - 1]
      console.log(ls)
      ls.parentNode.insertBefore(cid, ls.nextSibling) */
    },
    trackSignupButton() {
      var links = this.data.column
      links.forEach((element) => {
        element.list.forEach((list) => {
          if (list.clase == 'js-track-signup-discovery') {
            this.$EventsGA4.trackEvent('sign_up_button', {
              content: this.contentPage,
              mainConfig: this.mainConfig
            })
          }
        })
      })
    },
    clickLink(modalPageId, url) {
      if (this.linksWithModal) {
        this.$nuxt.$emit('openModalTerms', { modalPageId })
      } else {
        window.location.href = url
      }
    }
  }
}
